import {Queue} from '../../utils/queue.util';
import {Deferred} from '../../utils/deferred.util';
import Modal from '../../utils/modal';
import {NcaLayerResponse} from "../../types/ncaLayer";

export class WebSocketService {
  ws: WebSocket | undefined;
  socketIsOpen: number = 1;
  browseIsOpen = false;
  private queue: Queue<Deferred<NcaLayerResponse>> = new Queue<Deferred<NcaLayerResponse>>();
  private result: NcaLayerResponse | null = null;
  heartbeatInterval: ReturnType<typeof setInterval> | null = null;
  public readonly heartbeatMessage: string = '--heartbeat--'


  ping() {
    try { this.sendNotDeferredMessage(this.heartbeatMessage) }
    catch (error) {
      clearInterval(this.heartbeatInterval!);
      this.close()
    }
  }

  public setBrowseIsOpen(bool: boolean) {
    this.browseIsOpen = bool
  }

  createObservableSocket(url: string, resolve: () => void, reject: () => void): void {
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      resolve()
      if (!this.heartbeatInterval) {
        this.heartbeatInterval = setInterval(() => this.ping(), 1000)
      }
    }

    this.ws.onmessage = (event: MessageEvent<any>) => {
      if (event.data === this.heartbeatMessage) {
        // this.setBrowseIsOpen(false)
        return
      }

      this.result = new NcaLayerResponse();
      this.result.build(event.data);

      if(!!this.result?.result?.version) {
        return
      }

      if (!this.queue.isEmpty()) {
        this.queue!.pop()?.resolve(this.result);
      }
    };

    this.ws.onerror = (event) => {
      if (!this.queue.isEmpty()) {
        // @ts-ignore
        this.queue.pop().reject(event);
      }
    };

    this.ws.onclose = (event) => {
      reject();
      if (!event.wasClean) {
        const modal = new Modal();
        modal.open(`
          <h2>Ошибка при подключении к NCALayer</h2>
          <p>Убедитесь что программа NCALayer запущена и повторите попытку.</p>
        `);
        return
      }
      this.queue.clearAll();
    };
  }


  public sendMessage(message: string): Deferred<NcaLayerResponse>{
    const d = new Deferred<NcaLayerResponse>();
    this.queue.push(d);
    if (this.ws!.readyState === this.socketIsOpen) {
      this.ws!.send(message);
    }
    return d;
  }

  public sendNotDeferredMessage(message: string): void {
    this.ws!.send(message);
  }

  public close(): void {
    this.ws?.close();
  }
}
